<p-tabView #tabView>
  <p-tabPanel header="Business" #tabBusiness>
    <dashboard-engineius-general-kpi></dashboard-engineius-general-kpi>
  </p-tabPanel>
  <p-tabPanel header="Commercial" #tabCommercial>
    <ng-template pTemplate="content">
      <dashboard-engineius-commercial-kpi></dashboard-engineius-commercial-kpi>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Operational" #tabOperational>
    <ng-template pTemplate="content">
      <dashboard-engineius-operations-kpi></dashboard-engineius-operations-kpi>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Financial" #tabFinance>
    <ng-template pTemplate="content">
      <dashboard-engineius-financial-kpi></dashboard-engineius-financial-kpi>
    </ng-template>
  </p-tabPanel>
</p-tabView>
